import { forwardRef, createElement } from 'react';
import { ToggleButtonProps } from './';

import { BaseToggleButton } from './__internal__';

export const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(function ToggleButton(
  { icon, ...props },
  ref
) {
  return <BaseToggleButton {...props} ref={ref} icon={props.text ? undefined : icon} />;
});
